import React from 'react';

type Props = {
  onClick?: () => any;
  isHovering?: boolean;
  size?: number;
  hoverColor: string;
  color?: string;
  className?: string;
};

const MessengerIcon = (props: Props) => {
  const { isHovering, size, hoverColor, className, onClick } = props;
  const localHoverColor = hoverColor || '#757ed7';
  const iconSize = size || 45;
  const color = isHovering ? localHoverColor : props.color || '#fff';
  const sizing = `${iconSize}px`;

  return (
    <svg
      x="0px"
      y="0px"
      width={iconSize}
      height={sizing}
      className={className}
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      onClick={onClick}
    >
      <path
        fill={color}
        // tslint:disable-next-line
        d="M499.5,103.503c-217.049,0-393.002,164.533-393.002,367.496c0,115.46,56.945,218.482,146.002,285.854V897.5l134.118-74.394c35.754,10.009,73.646,15.389,112.882,15.389c217.049,0,393.002-164.534,393.002-367.497S716.549,103.503,499.5,103.503z M540.891,596.308L439.247,490.714L243.5,598.967l214.609-227.741L559.754,476.82L755.5,368.567L540.891,596.308z"
      />
    </svg>
  );
};

export default MessengerIcon;
